import { useCallback, useRef, useState } from 'react';

const usePopoverController = <T extends HTMLElement>() => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const popoverAnchor = useRef<T | null>(null);

  const closePopover = useCallback(() => {
    setIsPopoverOpen(false);
  }, []);

  const openPopover = useCallback(() => {
    setIsPopoverOpen(true);
  }, []);

  return {
    isPopoverOpen,
    openPopover,
    closePopover,
    popoverAnchor,
  };
};

export default usePopoverController;
